export default "__VITE_ASSET__DJ$imhBJ__"